import { render, staticRenderFns } from "./IssueLogModal.vue?vue&type=template&id=6c6b2f65&scoped=true&"
import script from "./IssueLogModal.vue?vue&type=script&lang=js&"
export * from "./IssueLogModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueLogModal.vue?vue&type=style&index=0&id=6c6b2f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b2f65",
  null
  
)

export default component.exports